import BasicActionPane from './BasicActionPane';

export default BasicActionPane;
export { BasicActionPane };
